import React, {useEffect, useState} from 'react';
import Dialog from "@mui/material/Dialog";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import IconTextView, {INPUT_TYPE} from "components/input/IconTextView";
import {getSmallTextViewHeight} from "my-styles/media/media";

import ICAddIcon from '@mui/icons-material/Add';

export default function RechargeWalletBox(props) {

    const [amountRecharge, setAmountRecharge] = useState(undefined)

    useEffect(() => {
        setAmountRecharge(undefined)
    }, [props.open])

    return (
        <div>
            <Dialog open={props.open} onClose={props.close} style={{height: 'auto'}} classes={'DialogStyle'}>
                <div>
                    <p className="marginTopBottomSmall titleBoxAmountRecharge">
                        ÙØ¨ÙØº ÙÙØ±Ø¯ ÙØ¸Ø± Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯
                    </p>
                    <div>
                        <div className="boxAmountRecharge">
                            <IconTextView
                                type={INPUT_TYPE.NUMBER}
                                className="boxAmountRechargeInput"
                                height={getSmallTextViewHeight()}
                                placeholder='ÙØ¨ÙØº (ØªÙÙØ§Ù)'
                                center={true}
                                value={amountRecharge}
                                onChange={(e) => {
                                    e.target.value = e.target.value.replace(/^\D+/g, '')
                                    if (e.target.value === "0" || e.target.value === "" || e.target.value <= 0) {
                                        setAmountRecharge(undefined)
                                        e.target.value = null
                                    } else {
                                        setAmountRecharge(e.target.value)
                                    }
                                }}/>
                        </div>
                        <div className="selectAmountBox">
                            <button
                                onClick={() => {
                                    if (props.onSubmit) {
                                        props.onSubmit(100000)
                                    }
                                }}>
                                {parseFloat("100000").toLocaleString('fa-IR')}
                            </button>
                            <button
                                onClick={() => {
                                    if (props.onSubmit) {
                                        props.onSubmit(200000)
                                    }
                                }}>
                                {parseFloat("200000").toLocaleString('fa-IR')}
                            </button>
                            <button
                                onClick={() => {
                                    if (props.onSubmit) {
                                        props.onSubmit(500000)
                                    }
                                }}>
                                {parseFloat("500000").toLocaleString('fa-IR')}
                            </button>
                        </div>
                    </div>
                    <div style={{display: 'flex'}} className="submitRechargeButton">
                        <div className="marginTopBottomSmall" style={{width: '88%'}}>
                            <IconTitleButtonRound
                                borderradius={"0.5rem"}
                                backgroundcolor={"var(--blue_3)"}
                                icon={<ICAddIcon style={{color: 'white'}}/>}
                                title="Ø§ÙØ²Ø§ÛØ´ ÙÙØ¬ÙØ¯Û"
                                height={"3em"}
                                width={"100%"}
                                direction="ltr"
                                fontSize="mediumTextBold"
                                lineHeight="1rem"
                                onClick={() => {
                                    if (props.onSubmit) {
                                        props.onSubmit(amountRecharge)
                                    }
                                }}/>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    )

}